import Vue from "vue";
import Vuex from "vuex";
import userStore from "./user";
import testStore from "./test";
import testsStore from "./tests";
import usersStore from "./users";
import companiesStore from "./companies";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user: userStore,
    users: usersStore,
    test: testStore,
    tests: testsStore,
    companies: companiesStore,
  },
});
